import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { RouteComponentProps, browserHistory } from 'react-router';
import { Tabs, TabContent, TabLink } from 'react-tabs-redux';
import { IStore } from 'redux/IStore';
import {
	getUserCardByCode,
	followUser,
	unfollowItem,
	changeTabAndGetRequiredData,
	closeWidgetAndResetUserFollowers,
	closeWidgetAndResetUserFollowing,
	setShowFollowers,
	setShowFollowing,
	resetData,
	getUserCardFollowButtonData,
	setIsMyProfile,
} from 'modules/user/usercard';
import { showModal, closeModal } from 'modules/modal';
import { setArticlesSortFilter, getArticles } from 'modules/magazine/article/articles';
import { updateCoverImage, updateProfileImage } from 'redux/modules/image';
import { CoverPicture, LoadingOverlayWrapper } from 'components';
import { IUserCardData, IUserCardAction } from 'models/user/usercard';
import { IUserPreferences } from 'models/user/userpreferences';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
import * as c from 'models/constants';
import { IModalAction } from 'models/modal';
import { IImageData, ICropImageData } from 'models/common';
import { IArticlesAction, IArticlesData } from 'models/magazine/article/articles';
import Helmet from 'react-helmet';
import { goToCard, formatInteger, getProfileTabUrl } from 'helpers/common';
import { AuthConsumer, ErrorPage, UserFollowers, UserFollowing } from 'containers';
import Appointments from '../Appointments';
import renderIcon from '../../../helpers/renderIcon';
import { UserAbout } from '../UserAbout';
import { getUserProfile } from 'redux/modules/user/userprofile';
import { IUserProfileAction } from 'models/user/userprofile';
import Reviews from '../Reviews';
import { changeTabAndGetRequiredDataFunction } from '../Helpers';
import ListingList from 'containers/Magazine/ListingList';
import { getAppointmentsByUser } from 'redux/modules/shop/appointments';
import { IAppointmentAction, IAppointmentState } from 'models/shop/appointments';
const { asyncConnect } = require('redux-connect');
import { thumbUrl } from 'helpers/common';

interface IProps extends RouteComponentProps<IParams, {}> {
	userCardData: IUserCardData;
	userPreferences: IUserPreferences;
	getUserCardByCode: (code: string) => IUserCardAction;
	getUserProfile: () => IUserProfileAction;
	followUser: (id: string, isUserCardFollowButton: boolean) => IUserCardAction;
	unfollowItem: (id: string, type: string, isUserCardFollowButton: boolean) => IUserCardAction;
	changeTabAndGetRequiredData: (selectedTab: string, userId: string) => IUserCardAction;
	closeWidgetAndResetUserFollowers: () => IUserCardAction;
	closeWidgetAndResetUserFollowing: () => IUserCardAction;
	setShowFollowers: (show: boolean) => IUserCardAction;
	setShowFollowing: (show: boolean) => IUserCardAction;
	expandProfile: () => IUserCardAction;
	resetData?: () => IUserCardAction;
	getUserCardFollowButtonData?: () => IUserCardAction;
	setIsMyProfile?: (isMyProfile: boolean) => IUserCardAction;
	t?: (key: string) => string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	updateProfileImage: (image: IImageData) => void;
	updateCoverImage: (image: IImageData) => void;
	setArticlesSortFilter?: (sort: number) => IArticlesAction;
	getArticles?: (userId: string, isFirstLoad: boolean) => IArticlesAction;
	getAppointmentsByUser?: (currentPage?: number) => IAppointmentAction;
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	location: any;
	dispatch?: any;
	articlesData?: IArticlesData;
	appointments?: IAppointmentState;
	baseUrlClient?: string;
}

interface IParams {
	code: string;
	shopId?: string;
}

interface IState {
	wardrobeVisible?: boolean;
	appointmentsSet: boolean;
	firstLoad: boolean;
}

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params }) => {
			const userCardData = (getState as () => IStore)().usercard;
			if (
				(!userCardData.usercard && params.code) ||
				(userCardData.usercard && params.code && params.code !== userCardData.usercard.code)
			) {
				return Promise.all([dispatch(getUserCardByCode(params.code))]);
			}
		},
	},
])
@connect(
	(state: IStore) => ({
		userCardData: state.usercard,
		userPreferences: state.userPreferences,
		sideMenu: state.sideMenu,
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		articlesData: state.articles,
		appointments: state.appointments,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		changeTabAndGetRequiredData: (selectedTab: string, userId: string) =>
			dispatch(changeTabAndGetRequiredData(selectedTab, userId)),
		followUser: (id: string, isUserCardFollowButton: boolean) => dispatch(followUser(id, isUserCardFollowButton)),
		unfollowItem: (id: string, type: string, isUserCardFollowButton: boolean) =>
			dispatch(unfollowItem(id, type, isUserCardFollowButton)),
		closeWidgetAndResetUserFollowers: () => dispatch(closeWidgetAndResetUserFollowers()),
		closeWidgetAndResetUserFollowing: () => dispatch(closeWidgetAndResetUserFollowing()),
		setShowFollowers: (show: boolean) => dispatch(setShowFollowers(show)),
		setShowFollowing: (show: boolean) => dispatch(setShowFollowing(show)),
		resetData: () => dispatch(resetData()),
		updateProfileImage: (image: ICropImageData) => dispatch(updateProfileImage(image)),
		updateCoverImage: (image: ICropImageData) => dispatch(updateCoverImage(image)),
		showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
		closeModal: () => dispatch(closeModal()),
		setArticlesSortFilter: (sort: number) => dispatch(setArticlesSortFilter(sort)),
		getArticles: (userId: string, isFirstLoad: boolean) => dispatch(getArticles(userId, isFirstLoad)),
		getUserCardByCode: (code: string) => dispatch(getUserCardByCode(code)),
		getUserCardFollowButtonData: () => dispatch(getUserCardFollowButtonData()),
		getUserProfile: () => dispatch(getUserProfile()),
		setIsMyProfile: (isMyProfile: boolean) => dispatch(setIsMyProfile(isMyProfile)),
		getAppointmentsByUser: (currentPage?: number) => dispatch(getAppointmentsByUser(currentPage, true)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserCard extends React.Component<IProps, IState> {
	private mainRef: React.RefObject<HTMLDivElement>;

	constructor(props) {
		super(props);

		this.followUser = this.followUser.bind(this);
		this.unfollowItem = this.unfollowItem.bind(this);
		this.handleOnEditProfileClick = this.handleOnEditProfileClick.bind(this);
		this.handleAppointmentsClick = this.handleAppointmentsClick.bind(this);
		this.editProfilePicture = this.editProfilePicture.bind(this);
		this.editCoverPicture = this.editCoverPicture.bind(this);
		this.addNewListing = this.addNewListing.bind(this);
		this.goToCard = this.goToCard.bind(this);

		this.mainRef = React.createRef<HTMLDivElement>();

		this.state = {
			appointmentsSet: false,
			firstLoad: true,
		};
	}

	public componentDidMount() {
		if (this.props.userPreferences.code || this.props.params.code !== 'me') {
			this.props.getUserCardByCode(this.props.params.code);
		}

		const { location } = this.props;

		if (this.props.userCardData && this.props.userCardData.usercard && this.props.userCardData.usercard.id) {
			if (location.query.tab && location.query.tab.length > 0) {
				this.props.changeTabAndGetRequiredData(location.query.tab, this.props.userCardData.usercard.id);
			} else {
				this.props.changeTabAndGetRequiredData(c.USERCARD_TAB_OVERVIEW, this.props.userCardData.usercard.id);
			}
		}
		if (this.props.getUserProfile) {
			this.props.getUserProfile();
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.userPreferences.code && this.props.userPreferences.code && this.props.params.code === 'me') {
			this.props.getUserCardByCode(this.props.params.code);
		}

		const { location } = this.props;
		// Apointments are shown only if user is the owner of the profile
		if (
			this.props.userCardData.usercard?.id === this.props.userPreferences?.id &&
			!this.props.userCardData.isMyProfile
		) {
			this.props.setIsMyProfile(true);
		}

		if (this.props.userCardData.isMyProfile && !this.state.appointmentsSet && !this.props.appointments?.items?.length) {
			Promise.all([this.props.getAppointmentsByUser(1), this.setState({ appointmentsSet: true })]);
		}

		if (!prevProps.userCardData.usercard && this.props.userCardData.usercard) {
			this.props.getUserCardFollowButtonData();
			if (location.query.tab && location.query.tab.length > 0) {
				this.props.changeTabAndGetRequiredData(location.query.tab, this.props.userCardData.usercard.id);
			} else {
				this.props.changeTabAndGetRequiredData(c.USERCARD_TAB_OVERVIEW, this.props.userCardData.usercard.id);
			}
		}
	}

	public componentWillUnmount() {
		this.props.resetData();
	}

	private handleListingsClick() {
		if (this.props && this.props.params && this.props.params.code) {
			browserHistory.push(`/profile/${this.props.params.code}${getProfileTabUrl('listings')}`);
		}
	}

	private handleAppointmentsClick() {
		if (this.props && this.props.params && this.props.params.code) {
			browserHistory.push(`/profile/${this.props.params.code}${getProfileTabUrl('appointments')}`);
		}

		if (this.props.appointments?.items?.length === 0 || this.state.firstLoad) {
			this.props.getAppointmentsByUser(1);
			this.setState({ firstLoad: false });
		}
	}

	private handleAboutClick() {
		if (this.props && this.props.params && this.props.params.code) {
			browserHistory.push(`/profile/${this.props.params.code}${getProfileTabUrl('about')}`);
		}
	}

	private handleOnEditProfileClick() {
		browserHistory.push('/userprofile');
	}

	public followUser() {
		this.props.followUser(this.props.userCardData.usercard.id, true);
	}

	public unfollowItem() {
		const userCard = this.props.userCardData.usercard;
		this.props.unfollowItem(userCard.id, JSON.parse(userCard.entityId).type, true);
		changeTabAndGetRequiredDataFunction(
			undefined,
			c.USERCARD_TAB_FOLLOWING,
			this.props.userCardData.usercard.id,
			this.props.changeTabAndGetRequiredData,
		);
	}

	private editProfilePicture() {
		this.props.showModal('CropImageModal', {
			type: c.NODE_TYPE_USER,
			closeModal: this.props.closeModal,
			saveImage: this.props.updateProfileImage,
			modalTitle: this.props.t('User_UserCard_ProfilePicture'),
			modalSize: 'small',
			imageId: this.props.userCardData ? this.props.userCardData.usercard.pictureId : undefined,
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: c.ASPECT_RATION_PROFILE_PICTURE,
				rotatable: true,
			},
			imageType: 'profile',
		});
	}
	private editCoverPicture() {
		this.props.showModal('CropImageModal', {
			type: c.NODE_TYPE_USER,
			closeModal: this.props.closeModal,
			saveImage: this.props.updateCoverImage,
			modalTitle: this.props.t('PortalPage_Section_Manage_Common_CoverPicture'),
			modalSize: 'small',
			imageId: this.props.userCardData ? this.props.userCardData.usercard.coverPictureId : undefined,
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: c.ASPECT_RATION_USER_COVER_PICTURE,
			},
			imageType: 'userBanner',
		});
	}
	private addNewListing() {
		this.props.showModal('AddNewListingModal', {});
	}

	private goToCard(id: string, type: string, target: string) {
		goToCard(this.props.dispatch, id, type, target);
	}

	public render() {
		if (this.props.userCardData.error) {
			return <ErrorPage {...this.props} message={this.props.userCardData.message} />;
		}
		const { t, userCardData, articlesData, params } = this.props;
		const { selectedTab, isMyProfile } = this.props.userCardData;

		if (!this.props.userCardData.usercard) {
			return null;
		}

		const { name, followersCount, followingCount, picture, shortDescription, code } = this.props.userCardData.usercard;
		const userUrl = this.props.baseUrlClient + '/profile/' + code;

		const topPart = () => (
			<>
				<div
					className="portalTopPartLarge overview row no-gutters"
					style={{ backgroundImage: `url(${thumbUrl(userCardData.usercard.coverPicture, 'banner')})` }}
				>
					{isMyProfile ? <div className="edit">{renderIcon('edit', 32, 32, '', this.editCoverPicture)}</div> : null}
					<div className="col align-self-end">
						<CoverPicture
							imageUrl={thumbUrl(picture, 'medium')}
							hasPicture={Boolean(picture)}
							editFunction={isMyProfile ? this.editProfilePicture : null}
						/>
						<h1>{name}</h1>
						<p className={`bio ${shortDescription ? 'white' : ''}`}>
							{(shortDescription && shortDescription !== null) || isMyProfile
								? shortDescription
								: `${t('Shop_ManageShop_Products_CreateProduct_Label_ShortDescription')}...`}
						</p>
						<div className="profile-actions d-flex flex-row">
							<div
								className={`bsPortalBtn ${
									userCardData.isFollowed ? 'btnEllipseGreyWhite' : 'btnEllipseGreenWhite'
								} text-capitalize`}
								onClick={
									isMyProfile
										? this.handleOnEditProfileClick
										: userCardData.isFollowed
										  ? this.unfollowItem
										  : this.followUser
								}
							>
								{isMyProfile
									? t('User_UserCard_EditProfile')
									: userCardData.isFollowed
									  ? t('BSPortal_Common_Unfollow')
									  : t('BSPortal_Common_Follow')}
							</div>
							<div className="follow-stats d-flex flex-row align-items-center">
								{renderIcon('followers')}
								<a
									href="#"
									onClick={(e) => {
										changeTabAndGetRequiredDataFunction(
											e,
											c.USERCARD_TAB_FOLLOWERS,
											this.props.userCardData.usercard.id,
											this.props.changeTabAndGetRequiredData,
										);
									}}
								>
									<p className="p14 text-lowercase">
										<span className="count">{formatInteger(followersCount)}</span>&nbsp;{t('User_UserCard_Followers')}
									</p>
								</a>
								<p className="p14 default-cursor">&nbsp;&nbsp;{'•'}&nbsp;&nbsp;</p>
								<a
									href="#"
									onClick={(e) => {
										changeTabAndGetRequiredDataFunction(
											e,
											c.USERCARD_TAB_FOLLOWING,
											this.props.userCardData.usercard.id,
											this.props.changeTabAndGetRequiredData,
										);
									}}
								>
									<p className="p14 text-lowercase">
										<span className="count">{formatInteger(followingCount)}</span>&nbsp;{t('User_UserCard_Following')}
									</p>
								</a>
							</div>
						</div>
					</div>
				</div>
			</>
		);

		return (
			<AuthConsumer>
				{() => {
					return (
						<>
							<div className="profile" ref={this.mainRef}>
								{topPart()}
								<div className="content">
									<div className="actions-container d-flex flex-row">
										<Tabs
											name={this.props.userCardData.tabsNamespace}
											tabComponent="div"
											className="profile-tabs"
											handleSelect={(selectedTab) => {
												changeTabAndGetRequiredDataFunction(
													null,
													selectedTab,
													this.props.userCardData.usercard.id,
													this.props.changeTabAndGetRequiredData,
												);
											}}
											renderActiveTabContentOnly={true}
											selectedTab={selectedTab === c.USERCARD_TAB_OVERVIEW ? c.USERCARD_TAB_LISTINGS : selectedTab}
										>
											<div className="tabs">
												<TabLink
													key="listingstablink"
													to={c.USERCARD_TAB_LISTINGS}
													onClick={() => this.handleListingsClick()}
												>
													<p>{t('User_ShopCard_Listings')}</p>
												</TabLink>
												{isMyProfile ? (
													<TabLink
														key="appointmentstablink"
														to={c.USERCARD_TAB_APPOINTMENTS}
														onClick={() => this.handleAppointmentsClick()}
													>
														<p>{t('User_UserCard_Appointments')}</p>
													</TabLink>
												) : null}
												<TabLink key="abouttablink" to={c.USERCARD_TAB_ABOUT} onClick={() => this.handleAboutClick()}>
													<p>{t('User_UserCard_About')}</p>
												</TabLink>
											</div>
											<div className="tabs-wrapper d-flex justify-content-center">
												<TabContent key="listingscontent" for={c.USERCARD_TAB_LISTINGS}>
													{isMyProfile ? (
														<div className="actionContainer d-flex flex-row align-items-center">
															{renderIcon('add', 40, 40, 'pointer', this.addNewListing)}
															<p className="p12 grayGigo">
																{articlesData?.items.length} {t('User_UserCard_Listings')}
															</p>
														</div>
													) : null}
													<ListingList selectedTab={selectedTab} />
												</TabContent>
												{isMyProfile ? (
													<TabContent key="appointmentscontent" for={c.USERCARD_TAB_APPOINTMENTS} className="container">
														<LoadingOverlayWrapper
															active={this.props?.appointments?.isFetching}
															className="loadingOverlayWrapper-appointments"
														>
															<Appointments
																appointments={this.props.appointments}
																isShopAppointment={false}
																loadMoreData={() =>
																	this.props.getAppointmentsByUser(this.props.appointments.itemsPage.currentPage + 1)
																}
															/>
														</LoadingOverlayWrapper>
													</TabContent>
												) : null}
												<TabContent key="aboutcontent" for={c.USERCARD_TAB_ABOUT} className="container">
													<div className="row">
														<div className="col-sm-4">
															<h1 className="title title1">{t('User_UserCard_About')}</h1>
														</div>
														<div className="col-sm-8">
															<UserAbout />
														</div>
													</div>
													<div className="row">
														<div className="col-sm-4">
															<h1 className="title title2">{t('User_UserCard_Reviews')}</h1>
														</div>
														<div className="col-sm-8">
															<Reviews shopId={params.shopId} />
														</div>
													</div>
												</TabContent>
												<TabContent key="followerstabcontent" for={c.USERCARD_TAB_FOLLOWERS} className="container">
													<div className="row">
														<div className="col-4 d-flex">
															<h1 className="title">{t('User_UserCard_Followers')}</h1>
														</div>
														<div className="col-8">
															<UserFollowers />
														</div>
													</div>
												</TabContent>
												<TabContent key="followingtabcontent" for={c.USERCARD_TAB_FOLLOWING} className="container">
													<div className="row">
														<div className="col-4 d-flex">
															<h1 className="title">{t('User_UserCard_Following')}</h1>
														</div>
														<div className="col-8">
															<UserFollowing />
														</div>
													</div>
												</TabContent>
											</div>
										</Tabs>
									</div>
								</div>
							</div>
							<Helmet
								title={name}
								link={[{ rel: 'canonical', href: userUrl }]}
								meta={[
									{ property: 'og:title', content: name },
									{ property: 'og:image', content: picture },
									{ property: 'og:description', content: shortDescription },
									{ property: 'og:url', content: userUrl },
									{ name: 'title', content: name },
									{ name: 'description', content: shortDescription },
									{ name: 'keywords', content: name },
								]}
							/>
						</>
					);
				}}
			</AuthConsumer>
		);
	}
}

export { UserCard };
